import { Mic, MessageSquare, Headphones, Volume2, Sparkles, BookOpen } from "lucide-react";
import HubLayout from "./HubLayout";

export default function Speak() {
  const day = Number(localStorage.getItem("currentDay") || 1);

  return (
    <HubLayout
      eyebrow="Speak"
      headline="Speak it like you"
      italic="mean it."
      subhead="Practice real conversations, sharpen your sound, and build the confidence to speak first — not hesitate."
      cards={[
        {
          Icon: MessageSquare, accent: "var(--rust)",
          title: "Practice scenarios",
          lede: "Twenty real-world conversations — interview, doctor, customer support. The AI plays the other side.",
          to: "/conversations",
        },
        {
          Icon: Mic, accent: "var(--gold-500)",
          title: "Today's oral lesson",
          lede: `Day ${day} — speaking drills that take your written knowledge into your mouth.`,
          to: `/oral/${day}`,
        },
        {
          Icon: Sparkles, accent: "var(--rust)",
          title: "Pronunciation gym",
          lede: "Minimal pairs, vowel mouth shapes, and stress patterns. Drill the sounds your tongue keeps tripping on.",
          to: "/pronunciation",
        },
        {
          Icon: Volume2, accent: "var(--gold-500)",
          title: "Free speaking",
          lede: "No script, no judge. Pick a topic, hit record, hear yourself, do it again.",
          to: "/speak-practice",
        },
        {
          Icon: Headphones, accent: "var(--sky)",
          title: "Listening practice",
          lede: "Train your ear before you train your tongue. Real speech at real speed, with optional transcript.",
          to: "/listening",
        },
        {
          Icon: BookOpen, accent: "var(--sage)",
          title: "Conversation practice",
          lede: "Open-ended chat with topic prompts. Useful when you want to talk, not drill.",
          to: "/conversation-practice",
        },
      ]}
    />
  );
}
